import React, { createContext, useContext, useEffect, useMemo, useReducer, useRef } from "react";
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { playoffMatchesHandlers, playoffMatchesInitialState, playoffMatchesReducer } from "../reducers/PlayoffMatchesReducer";

export const PlayoffMatchesContext = createContext()

export default function PlayoffMatchesProvider(props) {

  const {
    commonMatches,
    forBackup,
    forOverview,
    forPlayoff,
    forSummary,
    latestMatchesCount,
    matchScheduleDisplayType,
    matchScheduleType,
    poolKey,
    poolMatches,
    pools,
    previewMatches,
    // scheduleDisplayType,
    teamKey,
    tournamentType,
    directMatches,
  } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state ?? {}

  const _teamKey = teamKey ? teamKey : pathViews.teams

  const scheduleTypes = {
    district: pathViews && pathViews.districts && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    sport: pathViews && pathViews.sports ? true : false,
    team: teamKey || (pathViews && pathViews.teams) ? true : false,
    common: commonMatches ? true : false
  }

  let _sepBySection = true
  if (scheduleTypes.team || scheduleTypes.match || scheduleTypes.common) {
    _sepBySection = false
  }

  // sidebar
  const init = {
    _teamKey,
    commonMatches,
    matchScheduleType,
    matchScheduleDisplayType,
    previewMatches,
  }

  const [playoffMatches_state, playoffMatches_dispatch] = useReducer(playoffMatchesReducer, playoffMatchesInitialState(init));
  const playoffMatches_handlers = useMemo(
    () => playoffMatchesHandlers(playoffMatches_dispatch),
    [playoffMatches_dispatch]
  );

  const previousRef = useRef(null);

  // update the scheduledMatches
  // useEffect(() => {

  //   const current = {
  //     pathViews,
  //     _matches_info
  //   };

  //   if (!_matches_info) return;

  //   if (_.isEqual(previousRef.current, current)) return;

  //   previousRef.current = _.cloneDeep(current);

  //   console.log('INIT seasonMatchesProvider', _matches_info);

  //   seasonMatches_handlers.handleMatches_init(_matches_info, commonMatches);

  //   // if (_matches_info) {
  //   //   console.log('INIT seasonMatchesProvider', _matches_info, pathViews)
  //   //   seasonMatches_handlers.handleMatches_init(_matches_info, commonMatches)
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps 
  // }, [pathViews, _matches_info]);

  useEffect(() => {
    if (pools && poolMatches) {
      playoffMatches_handlers.handleMatches_initPlayoff(pools, poolMatches)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pathViews, poolMatches, pools]);


  return <PlayoffMatchesContext.Provider
    value={{ playoffMatches_state, playoffMatches_handlers }}>
    {props.children}
  </PlayoffMatchesContext.Provider>
}